// extracted by mini-css-extract-plugin
export var menuIcon = "_st-0";
export var menuIconInline = "_st-1";